<!-- Fixed Header -->
<ion-header class="ion-no-border">
  <!-- Clean Mobile Header -->
  <div class="bg-white border-b border-gray-100">
    <div class="px-6 py-4 max-w-sm mx-auto">
      <!-- Logo & Brand -->
      <div class="flex flex-col items-center gap-3">
        <div class="p-3 border border-gray-200 rounded-full">
          <img class="w-10 h-10" src="assets/icon/app-icon-transparent.svg" alt="App Icon" />
        </div>
        <div class="text-center">
          <h1 class="text-xl font-semibold text-gray-900">Willkommen!</h1>
          <p class="text-sm text-gray-500">Vervollständige dein Profil</p>
        </div>
      </div>
    </div>
  </div>
</ion-header>

<!-- Content -->
<ion-content [scrollY]="isEmailVerified">
  <div class="bg-white flex flex-col items-start px-6 pt-6 pb-12" [class.min-h-screen]="isEmailVerified">
    <div class="max-w-sm w-full mx-auto">

      <!-- Email Verification Notice -->
      <div *ngIf="!isEmailVerified" class="email-verification-card">
        <!-- Animated Icon -->
        <div class="icon-container">
          <div class="icon-ring">
            <div class="icon-inner">
              <i class="pi pi-envelope"></i>
            </div>
          </div>
          <div class="pulse-ring"></div>
        </div>

        <!-- Content -->
        <div class="text-center mb-6">
          <h3 class="text-lg font-semibold text-gray-900 mb-2">E-Mail bestätigen</h3>
          <p class="text-sm text-gray-500 leading-relaxed max-w-xs mx-auto">
            Wir haben dir eine Bestätigungs-E-Mail gesendet. Bitte klicke auf den Link in der E-Mail, um fortzufahren.
          </p>
        </div>

        <!-- Buttons -->
        <div class="flex flex-col gap-2 w-full">
          <button pButton type="button" label="Bestätigung prüfen" [loading]="loading"
            (click)="checkEmailVerification()" size="small" class="w-full"></button>
          <button pButton type="button" label="E-Mail erneut senden" [loading]="emailSent"
            (click)="sendVerificationEmail()" severity="secondary" [text]="true" size="small"
            class="w-full"></button>
          <button pButton type="button" label="Andere E-Mail verwenden" [loading]="changingEmail"
            (click)="useOtherEmail()" severity="secondary" [text]="true" size="small"
            class="w-full"></button>
        </div>

        <!-- Help Text -->
        <p class="text-xs text-gray-400 text-center mt-3">
          Keine E-Mail erhalten? Prüfe deinen Spam-Ordner.
        </p>
      </div>

      <!-- Success Message -->


      <!-- Form -->
      <form [formGroup]="personalDetailsForm" class="flex flex-col gap-5" *ngIf="isEmailVerified">

        <!-- First Name -->
        <div class="flex flex-col gap-1.5">
          <label class="text-sm font-medium text-gray-900">Vorname</label>
          <input pInputText id="first_name_field" [pAutoFocus]="true" type="text" placeholder="Dein Vorname"
            formControlName="first_name"
            class="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-lg bg-white focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 transition-all" />
        </div>

        <!-- Last Name -->
        <div class="flex flex-col gap-1.5">
          <label class="text-sm font-medium text-gray-900">Nachname</label>
          <input pInputText id="last_name_field" type="text" placeholder="Dein Nachname" formControlName="last_name"
            class="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-lg bg-white focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 transition-all" />
        </div>

        <!-- Date of Birth -->
        <div class="flex flex-col gap-1.5">
          <label class="text-sm font-medium text-gray-900">Geburtsdatum</label>
          <input pInputText id="date_of_birth_field" type="text" placeholder="TT.MM.JJJJ"
            formControlName="date_of_birth" maxlength="10" (input)="formatDateInput($event)"
            class="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-lg bg-white focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 transition-all" />
        </div>

        <!-- Regional Hub -->
        <div class="flex flex-col gap-1.5">
          <label class="text-sm font-medium text-gray-900">Regional-Hub</label>
          <p-select formControlName="regional_hub_id" [options]="regionalHubs" placeholder="Wähle deinen Regional-Hub"
            optionLabel="label" optionValue="value" [showClear]="true" appendTo="body"
            class="w-full">
          </p-select>
          <p class="text-xs text-gray-500">Wähle die Kommune, in der du teilnehmen möchtest</p>
        </div>

        <!-- Submit Button -->
        <button pButton type="button" (click)="completeOnboarding()" [disabled]="loading || personalDetailsForm.invalid"
          [loading]="loading" class="w-full !py-2.5 !text-sm !font-medium !rounded-lg !mt-3">
          Profil erstellen
        </button>

      </form>

    </div>
  </div>
</ion-content>